import { render, staticRenderFns } from "./AdDetail.vue?vue&type=template&id=3137b17e&scoped=true"
import script from "./AdDetail.vue?vue&type=script&lang=js"
export * from "./AdDetail.vue?vue&type=script&lang=js"
import style0 from "./AdDetail.vue?vue&type=style&index=0&id=3137b17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137b17e",
  null
  
)

export default component.exports